import { fetchJson } from '../utils/fetchJson';

export interface FounderProfile {
  _id: string;
  firstName: string;
  lastName?: string;
  role: string;
  profileImage?: string;
  linkedin?: string;
}

/** Seul filtre de rôles accessible sans authentification (requête « équipe » de /api/users). */
const PUBLIC_TEAM_ROLES = 'fondateur,freelancer,freelancer_admin';

// Une seule requête partagée entre les composants qui affichent le fondateur (hero, « Qui suis-je »).
let founderPromise: Promise<FounderProfile | null> | null = null;

/** Profil public du fondateur (photo, LinkedIn) ; null s'il n'existe pas. */
export function fetchFounderProfile(): Promise<FounderProfile | null> {
  if (!founderPromise) {
    founderPromise = fetchJson<{ users?: FounderProfile[] } | FounderProfile[]>(`/api/users?role=${PUBLIC_TEAM_ROLES}`)
      .then((data) => {
        const users = Array.isArray(data) ? data : data.users ?? [];
        return users.find((user) => user.role === 'fondateur') ?? null;
      })
      .catch((err: unknown) => {
        founderPromise = null;
        throw err;
      });
  }
  return founderPromise;
}
